import React, { useState } from "react";
import footLogo from "../images/footer/footer-Logo.svg";
import migration from "../images/footer/migration-allience.png";
import facebook from "../images/footer/facebook-logo.svg";
import linkedin from "../images/footer/linkedin-logo.svg";
import instagram from "../images/footer/instagram-logo.svg";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Importing icons

const Footer = () => {
  const [showEmployers, setShowEmployers] = useState(false);
  const [showIndividual, setIndividual] = useState(false);

  return (
    <div className=" bg-blue">
      <div className="container max-w-1440px mx-auto px-4 py-10 sm:px-8 lg:px-14">
        {/* Top Section */}
        <div className="flex flex-wrap justify-between items-center gap-4">
          <div>
            <Link to="/">
              <img
                className="w-[300px] md:w-full"
                src={footLogo}
                alt="Footer Logo"
              />
            </Link>{" "}
          </div>
          <div className="hidden md:block">
            <h2 className="hellix-font text-lg sm:text-[22px] font-semibold text-white flex items-center pb-3">
              Member of
            </h2>
            <div>
              <img src={migration} alt="Migration Alliance" />
            </div>
          </div>
        </div>

        {/* Middle Section */}
        <div className="flex flex-wrap justify-between pt-4">
          {/* Left Column */}
          <div className="w-full sm:w-1/4 text-white md:px-4 mb-4 md:mb-0">
            <div className="space-y-2">
              <h1 className="font-bold hellix-font text-xl sm:text-[22px] cursor-pointer">
                MARN: 2418453
              </h1>
              <div>
                <Link
                  to="/docs/code-of-conduct.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-normal hellix-font text-base underline opacity-80"
                >
                  MARA Code of Conduct
                </Link>
              </div>
              <div>
                <Link
                  to="/docs/consumer_guide_english.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-normal hellix-font text-base underline opacity-80"
                >
                  Migration Consumer Guide
                </Link>
              </div>
            </div>

            <div className="font-normal hellix-font text-sm opacity-80 leading-relaxed mt-6">
              <p className="mb-2">
                <strong>V Place Pty Ltd T/A Immiget Global (MARN 2418453)</strong> is a registered migration agent authorised to provide immigration assistance under the Migration Act 1958.
              </p>
              <p>
                Immiget Global is not a law firm. Information on this website is general in nature and does not constitute migration advice. Migration services are only provided in the context of a formal client agreement. Past results are not guaranteed for future outcomes.
              </p>
            </div>
          </div>

          <div className="hidden sm:block">
            {/* Work Visas */}
            <div className="w-full flex flex-col gap-y-4 mb-4 md:mb-0">
              <h3 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
                 Employer Sponsored Visas
              </h3>

              <Link
                to="/skills-in-demand-visa-482"
                className="font-medium hellix-font text-base text-white"
              >
                Skills in Demand SID (Subclass 482)
              </Link>
              <Link
                to="/subclass-186-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Employer Nomination Scheme (Subclass 186)
              </Link>
              <Link
                to="/subclass-494-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Skilled Employer Sponsored Regional (Subclass 494)
              </Link>
              <Link
                to="/subclass-407-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Training Visa (Subclass 407)
              </Link>
              <Link
                to="/working-holiday-visa"
                className="font-medium hellix-font text-base text-white"
              >
                Working Holiday Visa (Subclass 417, 462) 
              </Link>
              <Link
                to="/subclass-400-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Temporary Work Short Stay (Subclass 400)
              </Link>
            </div>
          </div>
          <div className="sm:hidden">
            <div className="flex flex-col  sm:flex-row gap-4">
              {/* For Employers */}
              <div className="w-full sm:w-1/4 flex flex-col gap-y-4 mb-4 md:mb-0">
                <h3
                  className="font-bold hellix-font text-xl sm:text-[22px] text-white cursor-pointer flex items-center gap-4"
                  onClick={() => setShowEmployers(!showEmployers)} // Toggle dropdown visibility
                >
                  Work Visas
                  {/* Displaying the chevron icon based on the state */}
                  {showEmployers ? (
                    <FaChevronUp className="text-white" />
                  ) : (
                    <FaChevronDown className="text-white" />
                  )}
                </h3>

                {/* Dropdown Links */}
                {showEmployers && (
                  <div className="flex flex-col gap-y-2">
                    <Link
                      to="/skills-in-demand-visa-482"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Skills in Demand SID (Subclass 482)
                    </Link>
                    <Link
                      to="/subclass-186-visa-australia-consultants"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Employer Nomination Scheme (Subclass 186)
                    </Link>
                    <Link
                      to="/subclass-494-visa-australia-consultants"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Skilled Employer Sponsored Regional (Subclass 494)
                    </Link>
                    <Link
                      to="/subclass-407-visa-australia-consultants"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Training Visa (Subclass 407)
                    </Link>
                    <Link
                      to="/working-holiday-visa"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Working Holiday Visa (Subclass 417, 462)
                    </Link>
                    <Link
                      to="/subclass-400-visa-australia-consultants"
                      className="font-medium hellix-font text-base text-white"
                    >
                      Temporary Work Short Stay (Subclass 400)
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="hidden sm:block">
            {/* Skilled Visas */}
            <div className="w-full flex flex-col gap-y-4 mb-4 md:mb-0">
              <h3 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
                Skilled Visas
              </h3>

              <Link
                to="/subclass-189-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Skill Select – Independent (Subclass 189)
              </Link>
              <Link
                to="/subclass-190-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Skill Select – Nominated (Subclass 190)
              </Link>
              <Link
                to="/subclass-491-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Skill Select – Working in Regional (Subclass 491)
              </Link>
              <Link
                to="/permanent-residence-regional-191"
                className="font-medium hellix-font text-base text-white"
              >
                Permanent Residence Regional (Subclass 191) 
              </Link>
              <Link
                to="/subclass-485-visa-australia-consultants"
                className="font-medium hellix-font text-base text-white"
              >
                Temporary Graduate (Subclass 485)
              </Link>
            </div>
          </div>


          <div className="sm:hidden">
            {/* Individual & Families */}
            <div className="w-full sm:w-1/4 flex flex-col gap-y-4 mb-4 md:mb-0">
              <h3
                className="font-bold hellix-font text-xl sm:text-[22px] text-white flex items-center gap-4 cursor-pointer"
                onClick={() => setIndividual(!showIndividual)}
              >
                Family & Spouse
                {showIndividual ? (
                  <FaChevronUp className="text-white" />
                ) : (
                  <FaChevronDown className="text-white" />
                )}
              </h3>
              {/* Dropdown Links */}
              {showIndividual && (
                <div className="flex flex-col gap-y-2">
                  <Link
                    to="/australia-visitor-visa-consultants"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Visitor Visa (Subclass 600, 601, 651)
                  </Link>
                  <Link
                    to="/partner-visa-australia"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Partner Visa (Subclass 820/801 & 309/100)
                  </Link>
                  <Link
                    to="/prospective-marriage-visa-300"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Prospective Marriage/Fiancé (Subclass 300)
                  </Link>
                  <Link
                    to="/subclass-143-parent-visa-australia-consultants"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Parent Visa (Subclass 103, 143)
                  </Link>
                  <Link
                    to="/child-visa"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Child Visa (Subclass 101, 102 & 802)
                  </Link>
                  <Link
                    to="/relatives-visa"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Relatives (Subclass 116, 836, 117, 115)
                  </Link>
                  <Link
                    to="/new-zealand-to-au"
                    className="font-medium hellix-font text-base text-white"
                  >
                    New Zealand to AU (Subclass 189, 461, 444)
                  </Link>
                  <Link
                    to="/resident-return-visa"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Resident Return (Subclass 155, 157)
                  </Link>
                  <Link
                    to="/citizenship"
                    className="font-medium hellix-font text-base text-white"
                  >
                    Citizenship
                  </Link>
                </div>
              )}
            </div>
          </div>



          {/* Other Links */}
          <div className="sm:w-1/6 flex flex-col gap-y-4 md:gap-y-6 items-start md:pt-8 mt-4">
            <h2 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
              <Link to="/skill-assessment-australia-consultants">
                Skill Assessment & Registration
              </Link>
            </h2>
            <h2 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
              <Link to="/news">News</Link>
            </h2>
            <h2 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
              <Link to="/best-migration-australia-consultants">About Us</Link>
            </h2>
            <h2 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
              <Link to="/immigration-office-australia-consultants">
                Contact Us
              </Link>
            </h2>
            <h2 className="font-bold hellix-font text-xl sm:text-[22px] text-white">
              <Link to="/sitemap.xml" target="_blank" rel="noopener noreferrer">
                Sitemap
              </Link>
            </h2>
          </div>

          <div className="block md:hidden">
            <h2 className="hellix-font text-lg sm:text-[22px] font-semibold text-white flex items-center pb-3">
              Member of
            </h2>
            <div>
              <img src={migration} alt="Migration Alliance" />
            </div>
          </div>
        </div>

        {/* Divider and Social Links */}
        <div className="hidden md:flex items-center justify-between mt-8">
          <div className="flex-1 h-[2px] bg-white"></div>
          <div className="flex justify-between gap-4 ml-4">
            <Link
              to="https://www.facebook.com/immigetglobal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="Facebook" />
            </Link>
            <Link
              to="https://www.linkedin.com/company/immigetglobal/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" />
            </Link>
            <Link
              to="https://www.instagram.com/immigetglobal/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" />
            </Link>
          </div>
          <div className="flex-1 h-[2px] bg-white ml-4"></div>
        </div>

        {/* Privacy and Terms Links */}
        <div className="hidden md:flex justify-between items-center mt-3">
          <div className="flex gap-4 text-sm hellix-font text-white">
            <Link to="/privacy-policy" className="hover:underline">
              Privacy Policy
            </Link>
            <span>|</span>
            <Link to="/terms-and-conditions" className="hover:underline">
              Terms & Conditions
            </Link>
          </div>
          <div className="font-normal text-base hellix-font text-white">
              Copyright ©{" "}
              <span className="font-semibold text-base hellix-font text-white">
                2024 Immiget Global.
              </span>{" "}
              All Rights Reserved.
          </div>
        </div>

        {/* responsive */}
        <div className="grid md:hidden mt-5">
          <hr />
          <div className="flex justify-center gap-10 ml-4 my-4">
            <Link
              to="https://www.facebook.com/immigetglobal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="Facebook" />
            </Link>
            <Link
              to="https://www.linkedin.com/company/immigetglobal/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" />
            </Link>
            <Link
              to="https://www.instagram.com/immigetglobal/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" />
            </Link>
          </div>

          <hr />

          <div className="w-full mt-3">
            <div className="flex flex-col gap-3 items-center">
              <div className="flex gap-4 text-sm hellix-font text-white">
                <Link to="/privacy-policy" className="hover:underline">
                  Privacy Policy
                </Link>
                <span>|</span>
                <Link to="/terms-and-conditions" className="hover:underline">
                  Terms & Conditions
                </Link>
              </div>
              <div className="font-normal text-base text-center hellix-font text-white">
                Copyright ©{" "}
                <span className="font-semibold text-base hellix-font text-white">
                  2024 Immiget Global.
                </span>{" "}
                All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
